import { translate } from "@/i18n";
import { canvasFeedbackMessages } from "@/i18n/messages/canvas-feedback";

export const MAX_FEEDBACK_ATTACHMENTS = 3;
export const MAX_FEEDBACK_ATTACHMENT_BYTES = 3 * 1024 * 1024;
export const FEEDBACK_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
] as const;
/** The same images by extension, for the desktop app's file picker. */
export const FEEDBACK_IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "webp"];

export interface FeedbackAttachment {
  filename: string;
  content_type: string;
  content: string;
}

export function feedbackAttachmentError(files: readonly File[]): string | null {
  if (files.length > MAX_FEEDBACK_ATTACHMENTS) {
    return translate(canvasFeedbackMessages, "attachLimit");
  }
  if (
    files.some(
      (file) =>
        !FEEDBACK_IMAGE_TYPES.some((type) => type === file.type) ||
        file.size === 0,
    )
  ) {
    return translate(canvasFeedbackMessages, "attachType");
  }
  if (
    files.reduce((total, file) => total + file.size, 0) >
    MAX_FEEDBACK_ATTACHMENT_BYTES
  ) {
    return translate(canvasFeedbackMessages, "attachSize");
  }
  return null;
}

export function encodeFeedbackAttachment(
  file: File,
): Promise<FeedbackAttachment> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read screenshot"));
    reader.onabort = () => reject(new Error("Screenshot read was cancelled"));
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string" || !result.includes(",")) {
        reject(new Error("Could not read screenshot"));
        return;
      }
      resolve({
        filename: file.name,
        content_type: file.type,
        content: result.slice(result.indexOf(",") + 1),
      });
    };
    reader.readAsDataURL(file);
  });
}
